import {APIClient} from "../api_helper";
import * as url from "../url_helper";

const api = new APIClient();

export const deviceRegisterAPI = data => {
    return api.create(url.DEVICE_REGISTER(data), data);
}
export const inquiryStartAPI = (orgId) => {
    return api.create(url.INQUIRY_START(orgId));
}
export const inquirySaveAPI = (orgId, id, data, isReview) => {
    return api.put(url.INQUIRY_SAVE(orgId, id, isReview), data);
}
export const inquirySubmitAPI = (orgId, id, data, action) => {
    return api.put(url.INQUIRY_SUBMIT(orgId, id, action), data);
}
export const inquiryGetAPI = (orgId, id) => {
    return api.get(url.INQUIRY_GET(orgId, id));
}

export const inquiryGetMediaAPI = (orgId, id) => {
    return api.get(url.INQUIRY_GET_MEDIA(orgId, id));
}
export const inquiryDeleteMediaAPI = (orgId, id, mediaId) => {
    return api.delete(url.INQUIRY_DELETE_MEDIA(orgId, id, mediaId));
}

export const inquiryCreateMediaAPI = (orgId, id, description, data, urlQueryObject) => {
    const formData = new FormData();
    formData.append('file', data, data.name)
    formData.append('name', data.name)
    formData.append('description', description)
    return api.upload(url.INQUIRY_CREATE_MEDIA(orgId, id, urlQueryObject), formData);

}
